import { Switch } from "@vega-core/components/Switch/Switch";

import {
  type FilterState,
  FilterType,
  type FilterValue,
  type SwitchFilterConfig,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  disabled?: boolean;
  filter: SwitchFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
};

export function SwitchFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  disabled = false,
  showLabel,
  tableId,
}: Props) {
  const filterValue = getFilterValue(filterState, filter.id, FilterType.Switch);

  const handleChange = (checked: boolean) => {
    onFilterChange(filter.id, checked);
  };

  // Use filter-level showLabel if specified, otherwise fall back to prop
  const shouldShowLabel = filter.showLabel ?? showLabel;

  return (
    <div
      className="flex items-center justify-between gap-2"
      data-testid={`${tableId}-switch-filter-${filter.id}-container`}
    >
      {shouldShowLabel ? (
        <p className="body-base-regular">{filter.label}</p>
      ) : null}
      <Switch
        checked={filterValue}
        disabled={Boolean(filter.props?.disabled || isLoading || disabled)}
        id={`${tableId}-${filter.id}`}
        onChange={handleChange}
        {...filter.props}
        label={shouldShowLabel ? undefined : filter.label}
      />
    </div>
  );
}
